import { render, staticRenderFns } from "./SetTimezone.vue?vue&type=template&id=2ddf6e9e"
import script from "./SetTimezone.vue?vue&type=script&lang=js"
export * from "./SetTimezone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ddf6e9e')) {
      api.createRecord('2ddf6e9e', component.options)
    } else {
      api.reload('2ddf6e9e', component.options)
    }
    module.hot.accept("./SetTimezone.vue?vue&type=template&id=2ddf6e9e", function () {
      api.rerender('2ddf6e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SetTimezone.vue"
export default component.exports